/************************************
MODULE:         Youtube video
WHAT IT DOES:   Youtube videos functionality via youtube video API
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
    var players = [],
        isIOS = window.App.globals.isMobile && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        isIpad = window.App.globals.isMobile && /iPad/.test(navigator.userAgent) && !window.MSStrea;

    function init() {
        initVideos();
        initPopups();
        $(window).off('video:init');
        $(window).on('video:init', initVideos);
    }

    function initPopups() {
        $(document).on('click', '.js-video-popup', initVideoInPopup);
        }

    function initVideoInPopup(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function")
            e.preventDefault();

        var link = $(e.target);
        if (!link.is('a'))
            link = link.parents('a');

        $(window).trigger('open:simplepopup', { data: link.data(), template: 'videopopup' });
    }

    function initVideos() {
        var videos = $('.js-video').not('.js-inited');
        if (!videos.length) {
            return;
        }
        initVideoPlayer();
    }

    function initVideoPlayer() {

        if (typeof window.onYouTubeIframeAPIReady == 'undefined') {

            //var tag = document.createElement('script'),
            //    firstScriptTag = document.getElementsByTagName('script')[0];
            //tag.async = true;
            //tag.src = "https://www.youtube.com/iframe_api";
            //firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = createVideoPlayer;

            $(window).on('video:pause', pauseVideo);
        } else {
            createVideoPlayer();
        }

    }

    function createVideoPlayer() {
        if (typeof YT == 'undefined' || !YT.loaded)
            return;

        var videos = $('.js-video').not('.js-inited');
        videos.addClass('js-inited');

        for (var i = 0; i < videos.length; i++) {
            var videoEl = videos.eq(i),
                videoContainer = videoEl.find('.js-video-container'),
                videoWidth = videoContainer.outerWidth(),
                videoHeight = videoContainer.outerHeight(),
                videoId = videoEl.attr('data-video-id');
            videoEl.attr('data-i', players.length);
            players[players.length] = new YT.Player(videoContainer[0], {
                width: videoWidth,
                height: videoHeight,
                videoId: videoId,
                playerVars: {
                    autoplay: 0,
                    rel: 0,
                    modestbranding: 1,
                    showinfo: 0,
                    wmode: "opaque"
                },
                events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
            videoEl.on('video:remove', removeVideo);

        }

        $(window).trigger('tabs:resize');
    }

    function onPlayerReady(event) {
        var parent = $(event.target.getIframe()).parents('.js-video'),
            videoPlayButton = parent.find('.js-play-video'),
            index = parseInt(parent.attr('data-i'));


        parent.addClass('is-ready');

        videoPlayButton.on('click', function (e) {
            e.preventDefault();
            players[index].playVideo();
        });
        videoPlayButton.show();

        if (isIOS) {
            videoPlayButton.css('pointer-events', 'none');
        }
    }

    function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING || event.data == YT.PlayerState.BUFFERING) {
            var video = $(event.target.getIframe()).parents('.js-video');
            video.addClass('is-playing');
            video.find('.js-play-video.js-track-postponed').trigger('gatrack:send');
        }
        if (event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED) {
            $(event.target.getIframe()).parents('.js-video').removeClass('is-playing');
        }
        if (event.data == YT.PlayerState.PAUSED && isIpad) {
            $(event.target.getIframe()).parents('.js-video').removeClass('is-ready');
        }
    }

    function removeVideo() {
        var i = parseInt($(this).attr('data-i'));
        pauseVideo();
        players.splice(i, 1);
        for (var j = i; j < players.length; j++) {
            $(players[j].f).parents('.js-video').attr('data-i', j);
        }
    }

    function pauseVideo(e) {
        for (var i = 0; i < players.length; i++) {
            if ((typeof players[i].getPlayerState == "function") && (players[i].getPlayerState() == YT.PlayerState.PLAYING)) {
                try {
                    players[i].pauseVideo();
                } catch(ex) {}
            }
        }
    }

    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.video.js
 ** module id = 67
 ** module chunks = 24
 **/